import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoomDetectionAutomatisch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 23 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(0.718075,0,0,0.677509,9.745309,19.96849)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M0,-21.867L5.402,-21.867",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			}), /* @__PURE__ */ _jsx("path", {
				d: "M10.269,-16.694L10.269,-3.012C10.269,-1.348 9.002,0 7.441,0L-8.754,0C-10.316,0 -11.582,-1.348 -11.582,-3.012L-11.582,-18.855C-11.582,-20.518 -10.316,-21.867 -8.754,-21.867L-6.088,-21.867L-2.654,-18.432",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.995747,0,0,0.995747,0.041834,0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.43,2.34C20.55,2.61 20.76,2.83 21.03,2.95L22.17,3.46C22.51,3.62 22.51,4.1 22.17,4.26L21.04,4.77C20.77,4.89 20.55,5.11 20.44,5.38L19.55,7.47C19.39,7.8 18.91,7.8 18.75,7.47L17.86,5.38C17.74,5.11 17.53,4.89 17.26,4.77L16.13,4.26C15.79,4.1 15.79,3.62 16.13,3.46L17.26,2.95C17.53,2.83 17.75,2.61 17.86,2.34L18.75,0.25C18.91,-0.08 19.39,-0.08 19.55,0.25L20.43,2.34Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.995747,0,0,0.995747,0.041834,0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22.69,8.34C22.69,8.87 22.27,9.31 21.76,9.31C21.25,9.31 20.83,8.88 20.83,8.34C20.83,7.8 21.25,7.37 21.76,7.37C22.27,7.37 22.69,7.8 22.69,8.34Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.995747,0,0,0.995747,0.041834,0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M14.61,1.93C15.13,1.93 15.54,1.5 15.54,0.96C15.54,0.42 15.13,0 14.61,0C14.09,0 13.68,0.43 13.68,0.97C13.68,1.51 14.1,1.94 14.61,1.94L14.61,1.93Z",
				fill: "currentColor"
			})
		})
	]
});
export default SvgRoomDetectionAutomatisch;
